import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_featured_specials: FaireCategoryEntity = {
  token: "cat_featured-specials",
  type: "category",
  name: "Brand specials",
  level: 2,
  parentToken: "cat_featured-brands",
  href: "/category/brand-specials",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
